import axios from 'axios';
import { getTenantId } from '../utils/accountHelper';

const grispiEndUserApi = axios.create({
    baseURL: process.env.NEXT_PUBLIC_BASE_URL
});
grispiEndUserApi.defaults.headers.post['Content-Type'] = 'multipart/form-data';

grispiEndUserApi.interceptors.request.use((req) => {
    req.headers.tenantId = getTenantId();
    return req;
});

export default grispiEndUserApi;
